import * as React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'

import CommonHeader from 'modules/locations/components/CommonHeader'
import locations from 'modules/locations/store/collections/locations'

const Container = () => {
  const params = useParams()
  const { id } = params
  const location = locations.get(Number(id))

  if (!location) return <NotFound />

  return (
    <CommonHeader location={location}>
      <Outlet context={{ location }} />
    </CommonHeader>
  )
}

export default Container
